module.exports = __webpack_public_path__ + "assets/windows-azure-blob.0fdd6f1a.svg";